<template>

  <div >
      <!-- 方式一：不使用<keep-alive>缓存页面状态 -->
      <!-- <router-view></router-view> -->
      <!-- 方式一：不使用<keep-alive>缓存页面状态 -->


      <!-- 方式二：使用<keep-alive>缓存页面状态 -->
      <router-view v-slot="{ Component, route }">
        <keep-alive>
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
      </router-view>
      <!-- 方式二：使用<keep-alive>缓存页面状态 -->
  </div>

</template>

<script type="text/javascript">

</script>

<style>

</style>
